module.exports = __webpack_public_path__ + "static/media/filter.bc9dd185.png";